import DrEventDetailed from './DrEventDetailed';

export default DrEventDetailed;
